"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ButtonVariants = exports.ButtonVariantTypes = exports.ButtonSizes = void 0;
var ButtonVariants = {
  Primary: 'primary',
  Secondary: 'secondary',
  Outline: 'outline',
  OutlineTransparent: 'outlineTransparent',
  Text: 'text'
};
exports.ButtonVariants = ButtonVariants;
var ButtonVariantTypes = {
  Default: 'default',
  Contrast: 'contrast',
  HighContrast: 'high-contrast',
  Generic: 'generic',
  Link: 'link'
};
exports.ButtonVariantTypes = ButtonVariantTypes;
var ButtonSizes = {
  Tiny: 'tiny',
  Small: 'small',
  Normal: 'normal',
  Big: 'big',
  Huge: 'huge'
};
exports.ButtonSizes = ButtonSizes;